/**
 * QR Menü ve Kiosk siparişleri için bildirim anahtarı ve "yeni sipariş" statü süzgeci.
 *
 * Anahtarda SiparisId KULLANILMAZ: kiosk numarası (D-2, P-3) her gün başa döner,
 * oturum boyu yaşayan useNewOrderQueue.seenKeysRef yarının D-2'sini dünden görülmüş
 * sayıp bildirimi yutar. Veritabanı kimliği hem push gövdesinde hem de yoklamadan
 * gelen satırda var ve asla tekrar etmez; emniyet ağı ile push aynı anahtarı üretir.
 */
export type MasaOrderSource = 'qrmenu' | 'kiosk' | 'ecommerce';

export function masaNewOrderNotificationKey(
  source: MasaOrderSource,
  order: { id?: string | number | null; siparisId?: string | null },
): string {
  const id = order.id != null && String(order.id) !== '0' ? order.id : order.siparisId ?? '';
  return `${source}|${id}|new-order`;
}

/** Modal ve ses yalnızca henüz işlenmemiş (onay bekleyen) sipariş için. */
export function isMasaNewOrderNotifiableStatus(raw?: string | null): boolean {
  const key = (raw || '').trim().toLowerCase();
  if (!key) return false;
  return key === 'beklemede' || key === 'bekliyor' || key === 'pending' || key === 'yeni' || key === 'new';
}
